// The RSVP dates — 2026 season (September through December), exact labels as supplied.
export const ALL_DATES = [
  { id: "2026-09-10", label: "Thu, Sep 10", date: new Date(2026, 8, 10) },
  { id: "2026-09-17", label: "Thu, Sep 17", date: new Date(2026, 8, 17) },
  { id: "2026-10-01", label: "Thu, Oct 1", date: new Date(2026, 9, 1) },
  { id: "2026-10-08", label: "Thu, Oct 8", date: new Date(2026, 9, 8) },
  { id: "2026-11-05", label: "Thu, Nov 5", date: new Date(2026, 10, 5) },
  { id: "2026-11-12", label: "Thu, Nov 12", date: new Date(2026, 10, 12) },
  { id: "2026-11-19", label: "Thu, Nov 19", date: new Date(2026, 10, 19) },
  { id: "2026-12-03", label: "Thu, Dec 3", date: new Date(2026, 11, 3) },
  { id: "2026-12-10", label: "Thu, Dec 10", date: new Date(2026, 11, 10) },
  { id: "2026-12-17", label: "Thu, Dec 17", date: new Date(2026, 11, 17) },
];

const MONTHS = ["january", "february", "march", "april", "may", "june",
  "july", "august", "september", "october", "november", "december"];

// Dates a visitor can RSVP for right now — current month, excluding past dates.
// Fallbacks keep the form usable off-season.
export function getVisibleDates() {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const pool = ALL_DATES.filter((d) => d.date >= startOfToday);

  const sameMonth = pool.filter(
    (d) => d.date.getMonth() === now.getMonth() && d.date.getFullYear() === now.getFullYear()
  );
  if (sameMonth.length) {
    return { monthLabel: MONTHS[now.getMonth()], dates: sameMonth, current: true };
  }

  if (pool.length) {
    const first = pool[0].date; // ALL_DATES is chronological, so this is the soonest upcoming
    const monthDates = pool.filter(
      (d) => d.date.getMonth() === first.getMonth() && d.date.getFullYear() === first.getFullYear()
    );
    return { monthLabel: MONTHS[first.getMonth()], dates: monthDates, current: false };
  }

  return { monthLabel: null, dates: [], current: false };
}

// The full season schedule grouped by month, for the read-only dropdown.
export function getFullSchedule() {
  const groups = [];
  const map = new Map();
  ALL_DATES.forEach((d) => {
    const key = `${d.date.getFullYear()}-${d.date.getMonth()}`;
    if (!map.has(key)) {
      const g = {
        key,
        monthLabel: `${MONTHS[d.date.getMonth()]} ${d.date.getFullYear()}`,
        dates: [],
      };
      map.set(key, g);
      groups.push(g);
    }
    map.get(key).dates.push(d);
  });
  return groups;
}
